// views/CRM/Analytics/blocks/FunnelChart.tsx
import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, Cell } from 'recharts';
import { fmtKwh, fmtNum } from '../../../../src/lib/funnelUtils';
import type { EventStage } from '../eventFunnel';

interface Props {
  stages: EventStage[];
}

// Versão simplificada do "Funil Macro" de AnalyticsComercialView.tsx (linhas
// ~917-951), sem o clique-para-drill-down (que abriria o card de negociação
// do Kanban — não faz sentido num painel executivo só-leitura). Mesmas cores,
// mesmos números, mesma fonte de dados (computeEventFunnel).
const FunnelChart: React.FC<Props> = ({ stages }) => {
  // #6331: a saída (Termo Reprovado) aparece no fim, em vermelho, marcada como saída.
  const dados = stages.map(s => ({ name: s.label, rotuloEixo: s.tipo === 'saida' ? `${s.label} (saída)` : s.label, valor: s.leads, kwh: s.kwh, fill: s.color, saida: s.tipo === 'saida' }));

  return (
    <div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={dados} margin={{ top: 20, right: 16, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#37415122" />
            <XAxis dataKey="rotuloEixo"tick={{ fontSize: 11 }} interval={0} />
            <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
            <Tooltip formatter={(v: any, name: any) => name === 'kwh' ? [fmtKwh(Number(v)), 'Volume'] : [fmtNum(Number(v)), 'Leads']} />
            <Bar dataKey="valor" radius={[6, 6, 0, 0]}>
              <LabelList dataKey="valor" position="top" style={{ fontSize: 12, fontWeight: 700 }} />
              {dados.map((d, i) => <Cell key={i} fill={d.fill} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className={`grid grid-cols-2 sm:grid-cols-3 gap-2 mt-3 ${dados.length > 5 ? 'lg:grid-cols-6' : 'lg:grid-cols-5'}`}>
        {dados.map(d => (
          <div key={d.name} className="text-left rounded-xl bg-gray-50 dark:bg-gray-700/40 px-3 py-2">
            <div className="flex items-center gap-1.5 mb-0.5">
              <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: d.fill }}></span>
              <p className={`text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide ${d.saida ? 'leading-tight' : 'truncate'}`} title={d.saida ? undefined : d.name}>{d.name}{d.saida && <span className="normal-case font-semibold text-red-600 dark:text-red-400"> · saída</span>}</p>
            </div>
            <p className="text-sm font-bold text-gray-900 dark:text-white leading-tight">{fmtNum(d.valor)} leads</p>
            <p className="text-[11px] font-semibold text-blue-600 dark:text-blue-400">{fmtKwh(d.kwh)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FunnelChart;
